// Copyright (c) 2016 Deere & Company

import View from './view';
import t from 'tcomb';

const Views = t.list(View, 'Views');

export const getDefaultState = () =>
    new Views([
        {
            columns: [
                {
                    key: 'requestPin',
                    value: 'Input PIN'
                },
                {
                    key: 'responsePin',
                    value: 'Output PIN'
                }
            ],
            name: 'standard view',
            sortBy: [
                {
                    key: 'requestPin',
                    order: 'DESC',
                    value: 'Input PIN'
                }
            ]
        }
    ]);

export default Views;



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/state/views.js